import { makeStyles } from "@material-ui/core";

export const vehiclePaveListStyle = makeStyles((theme) => ({
    card: {
        boxShadow: '2px 3px 10px #d7d6d6',
        padding: '1em',
        marginBottom: '1em',
        background: '#fff',
        width: '100%',
        borderRadius: '5px'
    },
    list: {
        maxHeight: '80vh',
        overflowY: 'auto'
    },
    link: {
        borderRadius: '5px',
        background: '#DDF0FF',
        textDecoration: 'none',
        fontSize: '0.8em',
        padding: '0.5em 1em',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    label: {
        color: theme.palette.primary.main,
        marginRight: '0.5em',
        fontWeight: '500'
    },
    value: {
        fontWeight: '500'
    },
    title: {
        color: '#242A31',
        fontWeight: '500',
    },
    titleWrapper: {
        width: '100%'
    },
    viewer: {
        boxShadow: '2px 3px 10px #d7d6d6',
        padding: '1em',
        //margin: '1em',
        width: '100%'
    },
    wrapper: {
        marginTop: '1em'
    }

}));